const NAME = "FUNCTIONS_SETTINGS_PAGE";

export default NAME;
